import React, { useState } from 'react';
import PropTypes from 'prop-types';
const Moment = require('moment');

// temp test stuff
import styled from '@emotion/styled';
import DatePicker from 'react-datepicker'; // for now, to toggle back and forth to test
let TestButton = styled.button`
    border: dashed 3px orange;
`;
// end of test stuff

const propTypes = {
    id: PropTypes.string.isRequired,
    className: PropTypes.string,
    minDate: PropTypes.object,
    maxDate: PropTypes.object,
    selected: PropTypes.object,
    onChange: PropTypes.func.isRequired,
    debug: PropTypes.bool,
    required: PropTypes.bool,
    ariaLabelledBy: PropTypes.string,
    disabled: PropTypes.bool,
    readOnly: PropTypes.bool,
}

const defaultProps = {
    className: '',
    debug: false,
    required: false,
    ariaLabelledBy: '',
    disabled: false,
    readOnly: false,
};

// accessible replacement for react-datepicker

function AccessibleDatePicker(props) {
    const [old, setOld] = useState(false);

    // for development only
    const toggleOldPicker = ()=> {
        setOld(!old);
    }

    // translate prop names
    let updatedProps = {...props};
    if (old) {
        updatedProps.onChange = (e)=>{
            console.log(`old DatePicker onChange value: ${typeof e} ${e}`); // FIXME: remove debug spam
            return props.onChange(e);
        }
    }
    else {
        if (typeof updatedProps.minDate !== 'undefined') {
            updatedProps.min = Moment(updatedProps.minDate).format('YYYY-MM-DD');
        }
        delete updatedProps.minDate;

        if (typeof updatedProps.maxDate !== 'undefined') {
            updatedProps.max = Moment(updatedProps.maxDate).format('YYYY-MM-DD');
        }
        delete updatedProps.maxDate;
        
        if (typeof updatedProps.selected !== 'undefined') {
            updatedProps.value = Moment(updatedProps.selected).format('YYYY-MM-DD');
        }
        delete updatedProps.selected;
        
        delete updatedProps.isClearable; // not supported (native input sometimes browser specific 'clear' button which is not controllable)
        
        if (updatedProps.ariaLabelledBy) {
            updatedProps['aria-labelledby'] = updatedProps.ariaLabelledBy;
        }
        delete updatedProps.ariaLabelledBy;
        
        updatedProps.onChange = (e)=>{
            let val = e.target.value;
            if (props.debug) {
                console.log(`native onChange value before adjustment: ${typeof val} ${val}`); // FIXME: remove debug spam
            }
            let utc = Moment(val).valueOf();
            let d = new Date();
            let msOffset = d.getMilliseconds() + (d.getSeconds() + (d.getMinutes() + d.getHours() * 60) * 60)*1000;
            let updatedValue = new Date(utc + msOffset);
            if (props.debug) {
                console.log(`native onChange value *after* adjustment: ${typeof updatedValue} ${updatedValue}`); // FIXME: remove debug spam
            }
            props.onChange(updatedValue);
        }
    }
    
    if (!props.debug) {
        // simple
        delete updatedProps.debug; // avoid react error console
        return (
            <input type="date" {...updatedProps}/>
        );
    }
        
    let str_date_range = `Date Range: ${props.minDate ? Moment(props.minDate).format('YYYY-MM-DD') : ''} to ${props.maxDate ? Moment(props.maxDate).format('YYYY-MM-DD') : ''}`; // FIXME: remove debug variable & span 

    return (
        <span className="accessible-date-picker">
            { old ? 
            <DatePicker {...updatedProps}/>
            :
            <input type="date" {...updatedProps}/>
            }
            { props.debug ?
            <>
                <TestButton className="bare-text-button glyph" onClick={toggleOldPicker} title={old ? "switch back to native date picker" : "use react-datepicker" }>
                    <span className={old ? "fa fa-toggle-off" : "fa fa-toggle-on"} />
                </TestButton>
                <span className="fa fa-info" title={str_date_range}/>
            </>
            : null }
        </span>
    );
}

AccessibleDatePicker.propTypes = propTypes;
AccessibleDatePicker.defaultProps = defaultProps;

export default AccessibleDatePicker;